import React, { useContext, useEffect } from "react"
import { AppContext } from "../../../components/AppProvider";
import { ContainerNew, ContainerVideo, SubMenu } from "../../Layout"
import VideoPlayer from "./VideoPlayer";
import { _O } from "../../../modules/utils";

export default (props) => {
  const { cfg } = useContext(AppContext);

  const iFrameStyle = {
    position: "absolute",
    width: "100%",
    height: "100%",
    left: "0",
  };

  // var tag = document.createElement('script');

  // tag.src = "https://www.youtube.com/iframe_api";
  // var firstScriptTag = document.getElementsByTagName('script')[0];
  // firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  //   // 3. This function creates an <iframe> (and YouTube player)
  //   //    after the API code downloads.
  // var player;
  // function onYouTubeIframeAPIReady() {
  //     player = new YT.Player('player', {
  //     height: '360',
  //     width: '100%',
  //     videoId: 'RnB8IDqShFw',
  //     events: {
  //         playerVars:{
  //             'autoplay':1
  //             // , 'mute':1
  //             , 'origin': cfg.webUrl
  //         },
  //         events:{ 'onReady':onPlayerReady }
  //     }
  //     });
  // }

  //   // 4. The API will call this function when the video player is ready.
  // function onPlayerReady(event) {
  //     event.target.playVideo();
  // }

  // function loadScript() {
  //     if (typeof(YT) == 'undefined' || typeof(YT.Player) == 'undefined') {
  //         var tag = document.createElement('script');
  //         tag.src = "https://www.youtube.com/iframe_api";
  //         var firstScriptTag = document.getElementsByTagName('script')[0];
  //         firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  //     }
  // }

  // function loadPlayer() {
  //         window.onYouTubePlayerAPIReady = function() {
  //             onYouTubeIframeAPIReady();
  //         };
  // }

  // useEffect(() => {
  //     loadScript();
  //     loadPlayer();
  // }, []);

  const youtubeOption = "?enablejsapi=1&autoplay=1&rel=0&origin=" + cfg.webUrl;

  return (
    <ContainerVideo
      Title={props.match.params.studyDesc}
      backEvent={() => _O.Open(decodeURIComponent(props.match.params.returnUrl))}
    >
      <div
        className="contents"
        id="contents"
        style={{
          backgroundColor: "#000",
          minHeight: "100vh",
          paddingTop: "0px",
          paddingBottom: "0px",
        }}
      >
        <div className="sub-contents">
          <div
            style={{
              position: "absolute",
              width: "90vw",
              height: "360px",
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            {props.match.params.studyDesc === "I" ? (
              <iframe
                src={
                  decodeURIComponent(props.match.params.linkUrl) + youtubeOption
                  // 네이버 동영상 "https://tv.naver.com/embed/29060045"
                }
                style={iFrameStyle}
                frameBorder="0"
                allowFullScreen
              />
            ) : (
              <VideoPlayer
                videoStyle={{
                  width: "100%",
                  height: "100%",
                  position: "absolute",
                }}
                videoId={decodeURIComponent(props.match.params.linkUrl)}
                thumbNail={decodeURIComponent(props.match.params.thumbNail)}
              />
            )}
          </div>
        </div>
      </div>
    </ContainerVideo>
  );
};